import { css } from "styled-components"

const imageStyles = css`
  max-width: 100%;
  height: auto !important;
`

export { imageStyles }
